import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import FloatingWhatsApp from './FloatingWhatsApp';

const Layout = ({ children }) => (
  <>
    <a href="#main-content" className="skip-to-main">
      Skip to main content
    </a>
    <Navbar />
    <main id="main-content">{children}</main>
    <Footer />
    <FloatingWhatsApp />
  </>
);

export default Layout;
